import React, { useEffect, useState } from "react";
import SectionTitle from "../../components/SectionTitle";
import { useDispatch, useSelector } from "react-redux";
import Aos from "aos";
import "aos/dist/aos.css";
import ChatbotComponent from "./ChatbotComponent";
import Loader from "../../components/Loader"; // Assuming you have a Loader component
import Footer from "../../components/Footer";

const Projects = () => {
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const dispatch = useDispatch();
  const { loading, portfolioData, error } = useSelector(
    (state) => state.root || {}
  );
  const { projects } = portfolioData || {};

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
    setIsVideoLoading(true);
    setTimeout(() => {
      Aos.init({ duration: 1000, once: true });
      Aos.refresh();
    }, 100);
  };

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  const handleVideoLoad = () => {
    setIsVideoLoading(false);
  };

  return (
    <div className="relative z-10 relative min-h-screen flex flex-col justify-between">
      <SectionTitle title="Projects" />
      <ChatbotComponent />

      <div className="flex sm:flex-col md:flex-col  sm:text-1xl font-poppins lg:pl-28 md:pl-24 lg:pr-5 md:pr-3 sm:px-2 ">
        <div className="flex flex-col sm:flex-row md:flex-row  gap-8 sm:gap-2 border-1-2 border-[#f97316] py-8 mt-12 sm:mt-4 space-y-5 sm:space-y-0 md:space-y-0 flex-1 sm:overflow-x-scroll md:overflow-x-scroll sm:scrollbar-hide md:scrollbar-hide sm:whitespace-nowrap md:whitespace-nowrap sm:w-full md:w-full">
          {projects.map((project, index) => (
            <div
              key={index}
              onClick={() => handleItemClick(index)}
              className={`cursor-pointer px-3 py-2 ${
                selectedItemIndex === index
                  ? "text-secondary border-l-2 border-secondary"
                  : "text-white"
              }`}
            >
              <h2 className="sm:text-xl  lg:text-2xl sm:gap-1 md:gap-2 font-semibold">
                {project.title}
              </h2>
            </div>
          ))}
        </div>
        <div className="sticky top-10 lg:top-40">
          <div className="flex items-center gap-10 md:gap-5 sm:flex-col lg:pl-20 md:pl-0 sm:px-0 sm:mt-4 sm:text-1xl left-44  sticky top-[170px] ">
            {isVideoLoading && <Loader />}{" "}
            {/* Show loader if video is loading */}
            {projects[selectedItemIndex].videoUrl ? (
              <iframe
                width="560"
                height="315"
                src={`${projects[selectedItemIndex].videoUrl}?rel=0`}
                title={projects[selectedItemIndex].title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="mt-12 h-80 w-90 sm:h-[220px] sm:w-full sm:px-3 md:w-[500px] "
                data-aos="fade-down"
                data-aos-delay="400"
                key={selectedItemIndex}
                onLoad={handleVideoLoad} // Handle video load event
                style={{ display: isVideoLoading ? "none" : "block" }} // Hide iframe while loading
              ></iframe>
            ) : (
              <img
                src={projects[selectedItemIndex].image}
                alt={projects[selectedItemIndex].title}
                className="mt-12 h-80 w-90 sm:h-[220px] sm:w-[350px]  text-white md:w-[400px] md:h-[250px]"
                data-aos="fade-down"
                data-aos-delay="400"
                key={selectedItemIndex}
                onLoad={handleVideoLoad} // Handle video load event
              />
            )}
            <div
              className="flex-1 flex-col gap-5 sm:gap-2 mt-12 sm:mt-6 sm:text-xl shadow border-r-2 border-b-2 shiny-border3 sm:p-0 w-full mb-3"
              data-aos="fade-top"
              data-aos-delay="400"
              key={`details-${selectedItemIndex}`}
            >
              {projects[selectedItemIndex] && (
                <div
                  className="p-6 md:p-2 rounded-lg shadow-lg text-white"
                  data-aos="fade-down"
                  data-aos-delay="1000"
                >
                  <h2 className="text-4xl mb-4 text-secondary font-bold">
                    {projects[selectedItemIndex].title}
                  </h2>
                  <p
                    className="mb-4 sm:mb-2 text-base font-poppins sm:text-base text-gray-200 leading-relaxed transition-all duration-500 ease-in-out transform hover:scale-105"
                    data-aos="fade-down"
                    data-aos-delay="800"
                  >
                    {projects[selectedItemIndex].description}
                    <a
                      href={projects[selectedItemIndex].proLink}
                      className="inline-flex items-center font-semibold text-blue-400 hover:text-transparent hover:bg-gradient-to-r hover:from-blue-400 hover:via-purple-500 hover:via-red-500 hover:to-pink-500 hover:bg-clip-text from-blue-300 hover:via-purple-400 hover:to-pink-400 transition-all duration-300 ease-in-out hover:underline"
                      alt={`Visit ${projects[selectedItemIndex].title}`}
                    >
                       here
                      <svg
                        className="w-5 h-5 ml-2 rtl:rotate-180 transition-transform duration-300 ease-in-out"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 10"
                      >
                        <path
                          stroke="#3b82f6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M1 5h12m0 0L9 1m4 4L9 9"
                        />
                      </svg>
                    </a>
                  </p>
                  <p
                    className="inline-flex lg:text-xl items-center font-semibold text-transparent bg-gradient-to-r from-blue-400 via-orange-500 via-purple-500 via-red-500 to-pink-500 bg-clip-text hover:from-blue-300 hover:via-purple-400 hover:to-pink-400 transition-all duration-300 ease-in-out hover:underline sm:text-base"
                    data-aos="fade-down"
                    data-aos-delay="400"
                  >
                    {projects[selectedItemIndex].technologies}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-auto w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Projects;
